import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { MenuItem, Select, SelectProps, FormControl, FormHelperText, InputLabel } from '@mui/material';

interface FormSelectProps<T extends FieldValues> extends Omit<SelectProps, 'name'> {
  name: Path<T>;
  control: Control<T, any, any>;
  options: Array<{ label: string | React.ReactNode; value: string | number }>;
  label?: string;
}

export const FormSelect = <T extends FieldValues>({
  name,
  control,
  options,
  label,
  ...selectProps
}: FormSelectProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl error={!!error} fullWidth data-rhf-field={String(name)}>
          {label && <InputLabel>{label}</InputLabel>}
          <Select variant="outlined" {...field} {...selectProps} label={label} size="small">
            {options.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {error && <FormHelperText>{error.message}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};
